<template>
  <div :class="$style.container">
    <progress
      :class="$style.progress"
      :max="total"
      :value="completed"
    />
    <p
      v-if="showCount"
      :class="$style.label"
    >
      completed {{ completed }} of {{ total }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'ProgressIndicator',

  props: {
    completed: {
      type: Number,
      default: 0,
    },
    showCount: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style module>
.progress[value] {
  appearance: none;
  border: none;
  border-radius: 3px;
  color: #007195;
  height: 6px;
  margin-bottom: 5px;
  position: relative;
  width: 100%;
}

.progress[value]::-webkit-progress-bar {
  background: #eaeaea;
  border-radius: 5px;
}

.progress[value]::-webkit-progress-value {
  background-color: #007195;
  border-radius: 5px;
  position: relative;
}

.progress[value]::-moz-progress-bar {
  background-color: #007195;
  border-radius: 5px;
  position: relative;
}

.label {
  color: #d9d8d8;
  font-weight: bold;
  margin-bottom: 10px;
}

</style>
